<div>
  <p class="bold light-blue no-margin mb-10">Liste {{index + 1}}</p>
  <div class="flex gap-10">
    <div class="flex flex-column" style="flex: 1;">
      <label class="dark-blue mb-5 text-sm">
        Nom de l'organisation syndicale
      </label>
      <input type="text" [(ngModel)]="list.name" placeholder="Saisissez le nom de l'organisation syndicale"
        (ngModelChange)="onUnionChange(index)" style="padding: 10px; border-radius: 5px; border: 1px solid #ccc;" />
    </div>

    <div class="flex flex-column" style="flex: 1;">
      <label class="dark-blue mb-5 text-sm">
        Pourcentage attribué
      </label>
      <input type="number" min="0" max="100" [(ngModel)]="list.percentage" (ngModelChange)="onUnionChange(index)"
        (wheel)="$event.preventDefault()"
        style="padding: 10px; border-radius: 5px; border: 1px solid #ccc; width: 100px;">
    </div>
  </div>
  <div class="flex gap-10">
    <div class="flex flex-column" style="flex: 1;">
      <label class="dark-blue mb-5 text-sm">
        Nom de l'organisation syndicale d'affiliation du syndicat
      </label>
      <input type="text" [(ngModel)]="list.parentOrg" placeholder="Saisissez le nom de l'os d'affiliation"
             (ngModelChange)="onUnionChange(index)" style="padding: 10px; border-radius: 5px; border: 1px solid #ccc;" />
    </div>
  </div>
</div>
